var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);
var Video = require( './video.jsx' );

var ToolboxWidget = createReactClass({
    mixins: [PureRenderMixin],

    getList: function(){
        return this.props.toolbox.education.map(function(item){
            return (
                <li key={item.topic}>
                    <LinkWrapper to={'/education/quality-of-life/toolbox#' + item.topic + '-topic'} handler={this.props.clickTracking}>
                        <span>{item.title}</span>
                        <span className="arrow">
                            <i className="ion-arrow-right-c"></i>
                        </span>
                    </LinkWrapper>
                </li>
            );
        }.bind(this));
    },

    render: function(){
        return (
            <div className="toolbox-widget clearfix">
                <h3>Quality of Life Toolbox</h3>
                <Video gender={this.props.gender} video={this.props.toolbox.featuredVideo} />
                <ul className="no-bullet">
                    {this.getList()}
                </ul>
            </div>
        )
    }
});

module.exports = ToolboxWidget;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/toolboxWidget.jsx